import { useTranslation } from 'react-i18next'
import type { CoinStanding } from '@brochure/shared'
import { cn } from '@/lib/utils'

type CoinsBoardProps = { coins: CoinStanding[]; highlightId?: string }

/**
 * Classifica dei saldi monete sulla carta della classifica: il più ricco su fondo sole, la riga dell'ospite
 * collegato evidenziata. Il saldo resta nell'ultima cella della riga (lo legge l'E2E).
 */
export function CoinsBoard({ coins, highlightId }: CoinsBoardProps) {
  const { t } = useTranslation()
  return (
    <div data-testid="coins-board" className="max-w-3xl overflow-hidden rounded-xl border border-ink/10 bg-paper shadow-card">
      <table className="w-full font-body text-sm">
        <thead>
          <tr className="border-b border-sun/45 bg-paper-deep/60 text-left text-xs tracking-[0.02em] text-ink-soft">
            <th scope="col" className="w-12 py-2.5 pl-4 font-semibold">
              #
            </th>
            <th scope="col" className="px-2 py-2.5 font-semibold">
              {t('zambePong.coins.participant')}
            </th>
            <th scope="col" className="py-2.5 pr-4 pl-2 text-right font-semibold">
              {t('zambePong.coins.balance')}
            </th>
          </tr>
        </thead>
        <tbody>
          {coins.map((entry, index) => {
            const isMe = entry.participantId === highlightId
            return (
              <tr key={entry.participantId} className={cn('border-b border-line/70 last:border-0', isMe && 'bg-sun/20')}>
                <td className="py-2.5 pl-4">
                  <span className={cn('grid size-6 place-items-center rounded-full text-xs font-bold tabular-nums', index === 0 ? 'bg-sun text-ink' : 'text-ink-soft')}>
                    {index + 1}
                  </span>
                </td>
                <td className={cn('max-w-0 truncate px-2 py-2.5 text-ink', isMe ? 'font-semibold' : 'font-medium')}>{entry.name}</td>
                <td className="py-2.5 pr-4 pl-2 text-right font-body text-lg tabular-nums text-ink">{entry.balance}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
